import { getCompanyInfoSectionVisibility } from '@aibees/elephant/components/company-info/utils';
import { useCompanyReadDataContext } from '@aibees/elephant/context';
import { memo } from 'react';
import { CompanyDescription } from '../company-description';
import { CompanySeoDescription } from '../company-seo-description copy';

export const CompanyDescriptionSeoWrapper = memo(() => {
  const { api } = useCompanyReadDataContext();
  const { showOverview, showSeo } = getCompanyInfoSectionVisibility(api?.data);

  return (
    <>
      {showOverview && <CompanyDescription />}
      {showSeo && <CompanySeoDescription />}
    </>
  );
});

CompanyDescriptionSeoWrapper.displayName = 'CompanyDescriptionSeoWrapper';
